export const Send = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.70982 6.56442C0.230861 5.38456 1.06516 3.00098 2.95708 3.00098H21.0265C22.5623 3.00098 23.5251 4.66025 22.7629 5.99356L13.9196 21.4629C12.9953 23.0797 10.557 22.6666 10.2169 20.8355L8.77338 13.0635L14.4944 9.81102C14.9745 9.53806 15.1424 8.92758 14.8695 8.44746C14.5965 7.96734 13.986 7.7994 13.5059 8.07236L7.7219 11.3607L1.70982 6.56442Z"
      fill="white"
    />
  </svg>
)

export default Send
